import React, { useEffect } from "react";
import "./All_Meditations.css";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import Blog_Card from "../insight/blogs/blog_card/Blog_Card";
import { useDispatch, useSelector } from "react-redux";
import { AllBlog } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";
import { useSearchParams } from "react-router-dom";

const All_Meditations = () => {
  const data = [
    {
      blog_title: "Focused Attention Meditation",
      blog_img: "/assets/images/insight/blogs/img1.png",
    },
    {
      blog_title: "Open Monitoring Meditation",
      blog_img: "/assets/images/insight/blogs/img2.png",
    },
    {
      blog_title: "Movement Meditation",
      blog_img: "/assets/images/insight/blogs/img1.png",
    },
    {
      blog_title: "Focused Attention Meditation",
      blog_img: "/assets/images/insight/blogs/img2.png",
    },
    {
      blog_title: "Focused Attention Meditation",
      blog_img: "/assets/images/insight/blogs/img1.png",
    },
    {
      blog_title: "Open Monitoring Meditation",
      blog_img: "/assets/images/insight/blogs/img2.png",
    },
    {
      blog_title: "Movement Meditation",
      blog_img: "/assets/images/insight/blogs/img1.png",
    },
    {
      blog_title: "Focused Attention Meditation",
      blog_img: "/assets/images/insight/blogs/img2.png",
    },
  ];

  const [searchParams] = useSearchParams();
  const blogCategoryId = searchParams.get("blog_category_id");

  // console.log({ blogCategoryId }); // "4"

  const dispatch = useDispatch();
  const all_blogs = useSelector((state) => state.common.all_blogs);

  useEffect(() => {
    dispatch(AllBlog({ blog_category_id: blogCategoryId }));
  }, [dispatch])

  return (
    <section className="All_Meditations">
      <div className="container">
        <Common_Back_Header backNavigation={-1} />

        <div className="all_cards_holder">
          <div className="row">
            {all_blogs?.map((item) => {
              return (
                <div className="col-lg-3 col-md-4 col-6 mb-4 p-sm-auto p-1">
                  <Blog_Card
                    link={`/meditation-blog-details/${item?.Blog?.id}`}
                    img={IDS.IMG_URL + item?.Blog?.image}
                    blogTitle={item?.name}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default All_Meditations;
